import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { buildProjectsLabel} from "../../utils/helpers/text/index";

const cellStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const ProjectRenderer = (params) => {
  const user = useSelector((state) => state.user);
  const row = params?.data || {};

  const projectLabel =  buildProjectsLabel({
    rowRedPandaProjects: row.redPandaProjects,
    userRedPandaProjects: user?.redPandaProjects,
    projectId: row.project,
  })

  if (!projectLabel || projectLabel === "-") {
    return <span>-</span>;
  }

  return (
    <Tooltip placement="top" arrow
      title={
        <span style={{ whiteSpace: "pre-line" }}>
          {projectLabel.replaceAll(", ", "\n")}
        </span>
      }
    >
      <div style={cellStyle} data-testid="project-cell">
        {projectLabel}
      </div>
    </Tooltip>
  );
};

export default ProjectRenderer;
